const IconBox = ({ name, imgURL }) => {
    return (
        <div className="techStacks gradient-color" >
            <img className="logo-size" src={imgURL} alt="icon" />
            <p className="text-center fs-5">{name}</p>
        </div>
    );
};


export const Skills = () => {
    return (
        <div id="skills" className="container top-margin techAnimation">
            <h1 className="my-4">Technical Skills</h1>
            <div className="gridFormat">
                <IconBox name={"HTML"} imgURL={"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-plain.svg"} />
                <IconBox name={"CSS"} imgURL={"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"} />
                <IconBox name={"Bootstrap"} imgURL={"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg"} />
                <IconBox name={"Tailwind"} imgURL={"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-plain.svg"} />
                <IconBox name={"JavaScript"} imgURL={"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"} />
                <IconBox name={"React"} imgURL={"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"} />
                <IconBox name={"Redux"} imgURL={"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg"} />
                <IconBox name={"Chakra UI"} imgURL={"chakra-ui.png"} />
                <IconBox name={"Node JS"} imgURL={"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg"} />
                <IconBox name={"Express"} imgURL={"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg"} />
                <IconBox name={"MongoDB"} imgURL={"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg"} />
                <IconBox name={"Git"} imgURL={"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg"} />
            </div>
        </div>
    );
};
